module.exports = __webpack_public_path__ + "static/media/icon-rabbi.75dca767.svg";